export const providerDisplayNames: { [key: string]: string } = {
  account_connection_login_key_oauth: 'Login Key OAuth',
  account_connection_un_pw_oauth: 'Username Password OAuth',
  account_connection_external_api_key: 'API Key',
};
